import { render, staticRenderFns } from "./OCRadio.html?vue&type=template&id=156a05ce&scoped=true&"
import script from "./OCRadio.ts?vue&type=script&lang=ts&"
export * from "./OCRadio.ts?vue&type=script&lang=ts&"
import style0 from "./OCRadio.css?vue&type=style&index=0&id=156a05ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a05ce",
  null
  
)

export default component.exports